// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqRequestModalStyles } from "@conklin/App/Components/RFQRequestModal/RFQRequestModal";
import QuestionCircle from "@conklin/XDL/Icons/QuestionCircle";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

rfqRequestModalStyles.modalStyle = {
    cssOverrides: {
        modalBody: css`
            width: 430px;
        `,
    },
};

rfqRequestModalStyles.requiredInformationText = {
    forwardAs: "p",
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        margin-bottom: 12px;
    `,
};

rfqRequestModalStyles.formGridContainer = {
    gap: 12,
};

rfqRequestModalStyles.firstNameGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.lastNameGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.emailGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.phoneGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.companyNameGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.addressGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.cityGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.stateGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.zipCodeGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        &&& {
            margin-bottom: 4px;
        }
    `,
};

rfqRequestModalStyles.enableTaxExemptWrapper = {
    css: css`
        margin: 16px 0;
        padding: 16px 0;
        border-bottom: 1px solid ${color("common.border")};
        border-top: 1px solid ${color("common.border")};
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    `,
};

rfqRequestModalStyles.enableTaxExemptTextWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

rfqRequestModalStyles.enableTaxExemptTooltip = {
    extendedStyles: {
        triggerWrapper: {
            css: css`
                display: flex;
            `,
        },
    },
    iconProps: {
        src: QuestionCircle,
        size: 18,
    },
};

rfqRequestModalStyles.enableTaxExemptRadioGroup = {
    horizontal: true,
    css: css`
        width: 70%;
        & > ${TypographyStyle} {
            display: none;
        }
    `,
};

rfqRequestModalStyles.enableTaxExemptText = {
    forwardAs: "p",
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

rfqRequestModalStyles.textExemptTextFieldWrapper = {
    css: css`
        width: 100%;
        ${({ taxExempt }: { taxExempt?: boolean }) => (taxExempt ? "display: block" : "display: none")};
    `,
};

rfqRequestModalStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        margin-top: 16px;
    `,
};

rfqRequestModalStyles.cancelButton = {
    variant: "secondary",
};
